<template>
    <div>
        <header>
            <el-form :inline="true" class="demo-form-inline" label-width="100px" size="small">
                <el-form-item label="客户名称" >
                    <el-input clearable v-model="condition" placeholder="请输入客户名称"
                        style="width: 100%;"></el-input>
                </el-form-item>
                <el-form-item >
                    <el-button type="primary" @click="getData">查询</el-button>
                    <el-button v-if="rolePermission === '领导' || rolePermission === '主管'" type="success" @click="update">增加</el-button>
                </el-form-item>
            </el-form>
        </header>
        <main>
                <el-table :data="list" height="calc(100vh - 136px)" :cell-style="rowStyle" id="tableId" ref="tableId"
                    style="font-size: 14px; " size="mini" :header-cell-style="{'text-align':'center'}">
                    <el-table-column label="序号" type="index" width="60" align="center">
                    </el-table-column>
                    <af-table-column label="客户名称" width="200" >
                        <template slot-scope="scope">
                            <!-- <i class="iconfont icon-bianmubianma"></i> -->
                            <el-link v-if="rolePermission === '领导' || rolePermission === '主管'" type="primary" @click="handleClick(scope.row)" >{{ scope.row.name }}</el-link>
                            <span v-else type="primary">{{ scope.row.name }}</span>
                        </template>
                    </af-table-column>
                    <af-table-column label="客户类别" align="center" prop="type" width="100" > </af-table-column>
                    <af-table-column label="客户地址"  width="600" prop="address" > </af-table-column>
                    <!-- <af-table-column label="客户电话" align="center">
                        <template slot-scope="scope">
                            <span>{{ scope.row.telNum }}</span>
                        </template>
                    </af-table-column> -->
                    <!-- <af-table-column label="联系人" align="center">
                        <template slot-scope="scope">
                            <span>{{ scope.row.contractMan }}</span>
                        </template>
                    </af-table-column> -->
                    <af-table-column label="开票信息" prop="invoiceInfo"  > </af-table-column>
                    <af-table-column label="操作" v-if="rolePermission === '领导' || rolePermission === '主管'"> 
                        <template slot-scope="scope">
                            <el-button type="primary" size="mini" plain @click="exitName(scope.row)">修改客户名称</el-button>
                            <el-button type="danger" size="mini" plain @click="delName(scope.row)">删除</el-button>
                        </template>
                    </af-table-column>
                    <!-- <af-table-column label="操作" align="center" v-if="rolePermission === '领导'">
                        <template slot-scope="scope">
                            <el-button round size="mini" icon="el-icon-bank-card" type="warning"
                                @click="amendRow(scope.row)">银行信息</el-button> -->
                            <!-- <el-button plain size="small" icon="el-icon-delete" type="danger"
                                @click="deleteRow(scope.row)">删除</el-button> -->
                        <!-- </template>
                    </af-table-column> -->
                </el-table>
            <!-- 添加更改客户信息弹框 -->
            <el-dialog title="更改客户信息" :close-on-click-modal="false" :show-close="false"
                :visible.sync="dialogFormVisible">
                <el-form :model="obj" ref="obj" :rules="rules">
                    <el-form-item label="客户名称" prop="name" >
                        <el-input :disabled="obj.id === '' ? false:true" v-model="obj.name" autocomplete="off" ></el-input>
                    </el-form-item>
                    <el-form-item label="客户类别" prop="type">
                        <el-select filterable clearable style="width: 100%;" v-model="obj.type"
                            placeholder="请选择客户类别">
                            <el-option v-for="item in typeOption" :key="item.id" :label="item.value"
                                :value="item.value">
                            </el-option>
                        </el-select>
                        <!-- <el-input v-model.trim="obj.type" autocomplete="off"></el-input> -->
                    </el-form-item>
                    <!-- <el-input v-model.trim="obj.type" autocomplete="off"></el-input> -->
                    <el-form-item label="客户地址" prop="address">
                        <el-input v-model="obj.address" autocomplete="off"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="客户电话" prop="telNum">
                        <el-input v-model="obj.telNum" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="联系人" prop="contractMan">
                        <el-input v-model="obj.contractMan" autocomplete="off"></el-input>
                    </el-form-item> -->
                    <el-form-item label="开票信息" prop="invoiceInfo">
                        <el-input type="textarea" v-model="obj.invoiceInfo" autocomplete="off"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="cancel">取 消</el-button>
                    <el-button type="primary" @click="confirmChange('obj')">确 定</el-button>
                </div>
            </el-dialog>
            <!-- 修改客户名称弹窗 -->
             <el-dialog title="修改客户名称" :visible.sync="exitNameCode" width="50%" :before-close="handleCloseExit" :close-on-click-modal="false" >
                <el-form ref="exitNameForm" :model="exitNameForm" label-width="80px" :rules="exitNameRules" >
                    <el-form-item label="当前名称">
                        <el-input  :disabled="true"  v-model="exitNameForm.name"></el-input>
                    </el-form-item>
                    <el-form-item label="修改名称" prop="newName">
                        <el-input v-model="exitNameForm.newName"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="handleCloseExit">取 消</el-button>
                    <el-button type="primary" @click="sureExitName('exitNameForm')">确 定</el-button>
                </span>
                </el-dialog>
            <!-- 客户银行信息弹框 -->
            <!-- <div>
                <el-dialog title="客户银行信息" :close-on-click-modal="false" :show-close="false"
                    :visible.sync="dialogCustmerVisible">
                    <div>
                        <el-button @click="addRow">添加行</el-button>
                        <el-button @click="saveAll" type="primary" style="margin-left: 10px">保存全部</el-button>
                        <el-table :data="tableData" :empty-text="'没有数据'" size="mini" style="width: 1000px">
                            <el-table-column prop="currency" label="币制" width="180">
                                <template slot-scope="scope">
                                    <el-select size="small" filterable clearable v-model="scope.row.currency" placeholder="请选择币制"
                                        v-show="scope.row.editing">
                                        <el-option v-for="item in typeInfo" :key="item.id" :label="item.value"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                    <span v-show="!scope.row.editing">{{ scope.row.currency }}</span> -->
                                    <!-- <el-select filterable clearable v-model.trim="scope.row.currency"
                                        placeholder="请选择币制">
                                        <el-option v-for="item in typeInfo" :key="item.id" :label="item.value"
                                            :value="item.value" v-show="scope.row.editing"></el-option>
                                    </el-select>
                                    <span v-show="!scope.row.editing">{{ scope.row.currency }}</span> -->
                                    <!-- <el-input v-model="scope.row.currency" placeholder="请输入币制"
                                        v-if="scope.row.editing"></el-input> -->
                                    <!-- <span v-show="!scope.row.editing">{{ scope.row.currency }}</span> -->
                                <!-- </template>
                            </el-table-column>
                            <el-table-column prop="account" label="账户名称" width="180">
                                <template slot-scope="scope">
                                    <el-input size="small" v-model="scope.row.account" placeholder="请输入账户名称"
                                        v-if="scope.row.editing"></el-input>
                                    <span v-show="!scope.row.editing">{{ scope.row.account }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="bankName" label="银行名称" width="180">
                                <template slot-scope="scope">
                                    <el-input size="small" v-model="scope.row.bankName" placeholder="请输入银行名称"
                                        v-if="scope.row.editing"></el-input>
                                    <span v-show="!scope.row.editing">{{ scope.row.bankName }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="accountNum" label="账户" width="180">
                                <template slot-scope="scope">
                                    <el-input size="small" v-model="scope.row.accountNum" placeholder="请输入账户"
                                        v-if="scope.row.editing"></el-input>
                                    <span v-show="!scope.row.editing">{{ scope.row.accountNum }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="100" >
                                <template slot-scope="scope">
                                    <el-button v-if="!scope.row.editing" @click="startEditing(scope.row)" type="text"
                                        size="small">
                                        编辑
                                    </el-button>
                                    <el-button v-else @click="save(scope.row)" type="text" size="small">
                                        保存
                                    </el-button>
                                    <el-button v-if="!scope.row.editing" @click="deleteRow(scope.row)" type="text"
                                        size="small" style="margin-left: 10px">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="dialogCustmerVisible = false">取 消</el-button>
                        <el-button type="primary" @click="allSaveList">确 定</el-button>
                    </div>
                </el-dialog>
            </div> -->
        </main>
    </div>
</template>

<script>
import req from '@/utils/index.js'
import url from '@/config/url2.js'
import url1 from '@/config/url1.js'
export default {
    name: 'correspondent',
    data() {
        return {
            rolePermission:localStorage.getItem('role'),
            typeOption: [],//往来单位分类
            companyId: '',
            null: '',
            condition: '',
            list: [],
            dialogFormVisible: false,
            // dialogCustmerVisible: false,//银行信息弹框
            obj: {
                id: '',
                name: '',
                address: '',
                telNum: '',
                contractMan: '',
                type: '',
                invoiceInfo:'',
            },
            typeInfo: [],//币制
            status: true,//状态
            options: [],//下拉框
            rules: {
                // name: [{ required: true, message: '请输入客户名', trigger: 'blur' }],
                address: [{ required: true, message: '请输入地址', trigger: 'blur' }],
                // telNum: [{ required: true, message: '请输入电话', trigger: 'blur' }],
                // contractMan: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
                type: [{ required: true, message: '请选择类别', trigger: 'blur' }],
                invoiceInfo: [{ required: true, message: '请输入开票信息', trigger: 'blur' }],

            },
            exitNameCode:false, // 修改客户名称弹窗
            exitNameForm:{
                newName:''
            }, // 修改客户名称表单
            exitNameRules:{
                newName: [{ required: true, message: '请输入修改后的名称', trigger: 'blur' }],
            },
            // tableData: [],
        }
    },
    // created() {
    //     this.getTypeOption();
    //     this.getTypeInfo();
    // },
    mounted() {
        this.getTypeOption();
        this.getTypeInfo();
        this.getData();
    },
    methods: {
        //获得type数据
        getTypeOption() {
            let value = '往来单位分类';
            let URL = `${url1.getDicList}/?value=${value}`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.typeOption = res.data.data.data;
                }
            })
        },
        rowStyle() {
            return "text-align:center";
        },
        // 查询任务列表
        getData() {
            // this.currentPage = page;
            let URL = `${url.getList}/?name=${this.condition}`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.list = res.data.data;
                    // this.computedStatus();         
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.message
                    })
                }
            })
        },
        //新增
        update() {
            this.obj = {
                id: '',
                name: '',
                address: '',
                telNum: '',
                contractMan: '',
                type: '',
                invoiceInfo:'',
            };
            this.dialogFormVisible = true;

        },
        //取消
        cancel() {
            this.$refs.obj.resetFields();
            this.obj.name = '';
            this.obj.address = '';
            this.obj.telNum = '';
            this.obj.contractMan = '';
            this.obj.invoiceInfo = '';
            this.obj.id = '';
            this.obj.type = '';
            this.dialogFormVisible = false;
        },
        //确认新增
        confirmChange(obj) {
            this.$refs[obj].validate((valid) => {
                if (valid) {
                    this.reqAdd();
                } else {
                    this.$message({
                        type: 'error',
                        message: '请填写完毕所有信息!'
                    })
                    return false;
                }
            });

        },
        reqAdd() {
            let URL = `${url.saveOrUpdateCustomer}`;
            req.post(URL, this.obj).then(res => {
                if (res.data.code === 200) {
                    this.$message({
                        type: 'success',
                        message: '更改成功'
                    })
                    this.getData();
                    this.cancel();
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.message
                    })
                }
            })
        },
        // 点击修改
        handleClick(row) {
            this.obj.name = row.name;
            this.obj.address = row.address;
            this.obj.telNum = row.telNum;
            this.obj.contractMan = row.contractMan;
            this.obj.invoiceInfo = row.invoiceInfo;
            this.obj.id = row.id;
            this.obj.type = row.type;
            this.dialogFormVisible = true;
        },
        // 打开修改名称弹窗
        exitName(data){
            this.exitNameCode = true
            this.exitNameForm = data
            // this.exitNameForm.newName = ''
            this.$set(this.exitNameForm, 'newName', ' ');
        },
        // 关闭修改客户名称
        handleCloseExit(){
            this.exitNameCode = false
            this.$refs.exitNameForm.resetFields();
            this.exitNameForm = {}
        },
        // 保存修改客户名称信息
        sureExitName(form){
            // 提示
            this.$confirm('是否确定修改客户名称', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 验证
                this.$refs[form].validate((valid) => {
                    if (valid) {
                        // 调用接口
                        let URL = `${url.changeCompanyName}/${this.exitNameForm.id}/${this.exitNameForm.newName}`;
                        req.put(URL).then(res => {
                            if (res.data.code === 200) {
                                this.$message({
                                    type: 'success',
                                    message: '更改成功'
                                })
                                this.getData();
                                this.handleCloseExit()
                            } else {
                                this.$message({
                                    type: 'error',
                                    message: res.data.message
                                })
                            }
                        })
                    } else {
                        return false;
                    }
                });
            }).catch(() => {
                // 取消
            });

        },
        // 银行信息
        // amendRow(row) {
        //     this.dialogCustmerVisible = true;
        //     let URL = `${url.getBankList}/${row.id}`;
        //     this.companyId = row.id;
        //     req.get(URL).then(res => {
        //         if (res.data.code === 200) {
        //             this.tableData = res.data.data;
        //             this.tableData.forEach(row => {
        //                 this.$set(row, 'editing', false);
        //             });
        //         } else {
        //             this.$message({
        //                 type: 'error',
        //                 message: res.data.message
        //             })
        //         }
        //     })
        // },
        // addRow() {
        //     const newRow = {
        //         account: '',
        //         bankName: '',
        //         accountNum: '',
        //         currency: '',
        //         editing: true,
        //         companyId: this.companyId
        //     };
        //     this.tableData.push(newRow);
        // },
        // deleteRow(row) {
        //     // 删除行的逻辑
        //     const index = this.tableData.indexOf(row);
        //     if (index !== -1) {
        //         this.tableData.splice(index, 1);
        //         if (row.id) {
        //             let URL = `${url.deleteBank}/${row.id}`;
        //             req.delete(URL).then(res => {
        //                 if (res.data.code === 200) {
        //                     this.$message({
        //                         type: 'success',
        //                         message: '删除成功'
        //                     })
        //                     this.amendRow();
        //                 } else {
        //                     this.$message({
        //                         type: 'error',
        //                         message: res.data.message
        //                     })
        //                 }
        //             })
        //         }

        //     }
        // },
        //币制
        getTypeInfo() {
            let value = '币制';
            let URL = `${url1.getDicList}/?value=${value}`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.typeInfo = res.data.data.data;
                }
            })
        },
        // 删除客户名称
        delName(data){
            this.$confirm('是否确定删除客户名称', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 调用接口
                // let URL = `${url.changeCompanyName}/${data.id}`;
                // req.delete(URL).then(res => {
                //     if (res.data.code === 200) {
                //         this.$message({
                //             type: 'success',
                //             message: '删除成功'
                //         })
                //         this.getData();
                //     } else {
                //         this.$message({
                //             type: 'error',
                //             message: res.data.message
                //         })
                //     }
                // })
            }).catch(() => {
                // 取消
            });
        }, 
        // startEditing(row) {
        //     this.$set(row, 'editing', true);
        // },
        // 确定保存
        // allSaveList() {
        //     let hasEmptyValue = false;
        //     this.tableData.forEach(row => {
        //         if (!row.currency || !row.account || !row.bankName || !row.accountNum) {
        //             hasEmptyValue = true;
        //             return false; // 提前退出循环
        //         }
        //     });
        //     if (hasEmptyValue) {
        //         this.$message.warning('请填写完整空白内容');
        //     } else {
        //         let flag = false;
        //         this.tableData.forEach(row => {
        //             if (row.editing == true) {
        //                 flag = true;
        //             }

        //         })
        //         if (flag) {
        //             this.$message({
        //                 type: 'warning',
        //                 message: '请先保存全部！'
        //             })
        //         } else {
        //             let URL = `${url.addBankList}`;
        //             req.post(URL, this.tableData).then(res => {
        //                 if (res.data.code === 200) {
        //                     this.$message({
        //                         type: 'success',
        //                         message: '更改成功'
        //                     })
        //                     this.amendRow();
        //                 } else {
        //                     this.$message({
        //                         type: 'error',
        //                         message: res.data.message
        //                     })
        //                 }
        //             })
        //         }
        //     }
        // },
        // save(row) {
        //     this.$set(row, 'editing', false);
        // },
        // saveAll() {
        //     this.tableData.forEach(row => {
        //         // row.editing = false;
        //         this.$set(row, 'editing', false);
        //     });
        // }

    },
}
</script>

<style lang="css" scoped>
.hoverStyle:hover {
    color: blue;
    /* 设置悬停时的字体颜色 */
    text-decoration: underline;
    /* 添加下划线 */
}
::v-deep .el-form-item {
    margin-bottom: 10px;
}
::v-deep .el-table {
    margin-top: 0px;
}

::v-deep .cell {
    /* white-space: nowrap; */
    /* overflow: auto; */
    /* display: inline-block; */
}
</style>